import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
  provideHttpClient,
  withFetch,
} from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpInterceptorInterceptor } from './core/interceptors/http-interceptor.interceptor';
import { NotFoundComponent } from './site/feature-modules/not-found/not-found.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

import localeEn from '@angular/common/locales/en';
import localeAr from '@angular/common/locales/ar';
import { registerLocaleData } from '@angular/common';
import { register as registerSwiperElement } from 'swiper/element/bundle';
import { HeaderComponent } from './site/landing-page/template-one/layout-template-one/header/header.component';
import { NgxsModule } from '@ngxs/store';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { CompanyInfoState } from './core/store/companyInfo/company-info-state';
import { ClientDetailsState } from './core/store/clientDetails/client-details.state';
import { FormsModule } from '@angular/forms';
import { PlaceState } from './core/store/place/place.state';
import { BranchState } from './core/store/branch/branch.state';
import { CartState } from './core/store/cart/cart.state';

registerSwiperElement();
registerLocaleData(localeEn);
registerLocaleData(localeAr);

@NgModule({
  declarations: [AppComponent, NotFoundComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    HeaderComponent,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgxsModule.forRoot([CompanyInfoState,ClientDetailsState,PlaceState,BranchState,CartState], { developmentMode: true }),
    NgxsLoggerPluginModule.forRoot(),
    NgxsReduxDevtoolsPluginModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorInterceptor,
      multi: true,
    },
    provideHttpClient(withFetch()) // Enable fetch API
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
